/**
 * referralContent.js — тексты рефералки и копирование кода.
 *
 * Логика с бэкенда (payments/router.py):
 * 1. Коллега пишет код в referred_by при регистрации.
 * 2. Пробный платёж (~1 ₽) бонусов не даёт.
 * 3. Первый платёж по тарифу (> 100 ₽): коллеге +7 / +31 день, вам +31 день
 *    (только если у вас активна подписка и есть rebillId).
 * 4. Повторные списания бонусов не дают.
 *
 * REFERRAL_STEPS      — три шага в модалке (icon: share | card | gift)
 * REFERRAL_REWARDS    — карточки «Вы» и «Коллега»
 * REFERRAL_IMPORTANT  — пункты блока «Важно»
 * copyReferralCode    — буфер обмена (Clipboard API + fallback)
 * getReferralModalDensity — узкий / низкий / телефон (sheet ≤540, как ModalQuestion)
 */

/** Телефон: sheet снизу. Порог по innerWidth — body.zoom не должен сбивать breakpoint. */
export const getReferralModalDensity = (width, height) => {
  const viewportWidth =
    typeof window !== "undefined" ? window.innerWidth : width;
  return {
    isPhone: viewportWidth <= 540,
    isNarrow: width < 560 || viewportWidth < 560,
    isShort: height < 820,
  };
};

export const REFERRAL_STEPS = [
  {
    n: "1",
    title: "Коллега регистрируется",
    text: "Вводит ваш промокод",
    icon: "share",
  },
  {
    n: "2",
    title: "Пробный период",
    text: "Оплачивает любой тариф по окончанию срока",
    icon: "card",
  },
  {
    n: "3",
    title: "Бонус после оплаты",
    text: "Месяц вам и бонус коллеге",
    icon: "gift",
  },
];

export const REFERRAL_REWARDS = [
  {
    id: "you",
    label: "Вы",
    reward: "+1 месяц",
    rewardHint: "подписки бесплатно",
    footer:
      "Один раз, когда коллега первый раз оплатит тариф после пробного периода.",
  },
  {
    id: "colleague",
    label: "Коллега",
    reward: "+1 неделя",
    rewardHint: "или месяц в подарок",
    footer:
      "При первой оплате: месяц +7 дней, год +31 день. Не за пробный период.",
  },
];

export const REFERRAL_IMPORTANT = [
  "Можно приглашать неограниченное количество коллег",
  "Бонус вам начисляется, только если у вас активна подписка и привязана карта",
  "Бонусы приходят автоматически после первой оплаты коллеги — не за пробный период и не за повторные списания",
];

export const copyReferralCode = (value) => {
  const fallback = () => {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  };

  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(value).catch(() => fallback());
  }
  return Promise.resolve(fallback());
};
